import { render, staticRenderFns } from "./DynamicPlatformUpload.vue?vue&type=template&id=ff68c29e&scoped=true&"
import script from "./DynamicPlatformUpload.vue?vue&type=script&lang=js&"
export * from "./DynamicPlatformUpload.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPlatformUpload.vue?vue&type=style&index=0&id=ff68c29e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff68c29e",
  null
  
)

export default component.exports